import { useCallback, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { nanoid } from 'nanoid'

import { firebase } from '../../core/services'

import {
  ANALYTICS_EVENT_CATEGORIES,
  ANALYTICS_EVENTS,
} from '../../common/constants'
import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { MENU_CURATION_TASK_QUERY } from '../graphql/queries'
import { FETCH_MENU_CURATION_TASK } from '../redux/action-types'
import { cleanupFetchMenuCurationTask } from '../redux/actions'

const useMenuCurationTaskQuery = id => {
  const sessionId = useRef(nanoid())
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchMenuCurationTask)
  const { isLoading, error, data } = useSelector(
    store => store.menuCurationTasks.menuCurationTask,
  )
  const refetch = useCallback(
    id => {
      firebase.logEvent(
        ANALYTICS_EVENTS.MENU_CURATOR_LOAD_MENU_TASK
          .MENU_CURATOR_START_LOAD_MENU_TASK,
        {
          sessionId: sessionId.current,
          menuCurationTaskId: id,
          eventCategory: ANALYTICS_EVENT_CATEGORIES.MENU_CURATOR_LOAD_MENU_TASK,
        },
      )

      apolloService.query({
        query: MENU_CURATION_TASK_QUERY,
        variables: {
          id,
        },
        dispatch,
        onSuccess: () =>
          firebase.logEvent(
            ANALYTICS_EVENTS.MENU_CURATOR_LOAD_MENU_TASK
              .MENU_CURATOR_END_LOAD_MENU_TASK,
            {
              sessionId: sessionId.current,
              menuCurationTaskId: id,
              eventCategory:
                ANALYTICS_EVENT_CATEGORIES.MENU_CURATOR_LOAD_MENU_TASK,
            },
          ),
        action: FETCH_MENU_CURATION_TASK,
      })
    },
    [dispatch],
  )

  useEffect(() => {
    refetch(id)
  }, [refetch, id])

  return { isLoading, error, data, refetch }
}

export default useMenuCurationTaskQuery
